// extracted by mini-css-extract-plugin
export default {"label":"c2cde2","label--log":"d498f1","label--warning":"b74da7","label--dangerous":"c1c9e4","label--critical":"b590c3","label--success":"f86011"};